import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocNotification } from '../models/doc-notification';

@Injectable({
  providedIn: 'root'
})
export class DocNotificationService {

  constructor( private http:HttpClient ) { }

  async getDocNotifications() : Promise<DocNotification[]> {
    return this.http.get<DocNotification[]>('/api/document_notification')
      .toPromise();
  }

  async postDocNotification(doc:DocNotification) : Promise<DocNotification> {
    return this.http.post<DocNotification>('/api/document_notification', doc)
      .toPromise();
  }

  async getDocNotification(id:Number) : Promise<DocNotification> {
    return this.http.get<DocNotification>('/api/document_notification/' + id)
      .toPromise();
  }
  
  async putDocNotification(doc:DocNotification) : Promise<DocNotification> {
    return this.http.post<DocNotification>('/api/document_notification/' + doc.id + '/edit', doc)
      .toPromise();
  }
  
  async deleteDocNotification(doc:DocNotification) : Promise<void> {
    return this.http.get<void>('/api/document_notification/' + doc.id + '/delete')
      .toPromise();
  }
}
